/* import __COLOCATED_TEMPLATE__ from './tile.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { Severity } from '@sentry/browser';
import { Action, MessageUnit } from '@square/dashboard-protos/models/squareup/messageservice/service';
import { BANKING_HOME_PAGE_PLACEMENT_ID } from '@banking/api/services/message-service-api';
// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';
let BankingTile = (_dec = computed('args.messageUnits.length', 'cursor'), _dec2 = computed('currentMessage.{sposTileFormat,tileFormat}'), _dec3 = computed('args.messageUnits.length'), _dec4 = computed('args.messageUnits.length'), (_class = class BankingTile extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "sentry", _descriptor, this);
    _initializerDefineProperty(this, "messageServiceApi", _descriptor2, this);
    _initializerDefineProperty(this, "cursor", _descriptor3, this);
  }
  get currentMessage() {
    if (this.cursor >= 0 && this.cursor <= this.args.messageUnits.length - 1) {
      const currentMessage = this.args.messageUnits[this.cursor];
      if (currentMessage instanceof MessageUnit) {
        this.trackEngagement(currentMessage, Action.VIEW);
      }
      return currentMessage;
    } else {
      this.sentry.captureMessage('Tried to access out of range messageUnit', Severity.Warning);
      throw new Error('Tried to access out of range messageUnit');
    }
  }
  get currentTile() {
    if (this.currentMessage?.tileFormat !== undefined) {
      return this.currentMessage?.tileFormat;
    } else if (this.currentMessage?.sposTileFormat !== undefined) {
      return this.currentMessage?.sposTileFormat;
    } else {
      return undefined;
    }
  }
  get showTile() {
    return this.args.messageUnits?.length > 0;
  }
  get showPagination() {
    return this.args.messageUnits?.length > 1;
  }
  openMessageUnitLink(messageUnit) {
    this.trackEngagement(messageUnit, Action.CLICK);
    theWindow.open(this.currentTile?.linkUrl, '_blank', 'noopener noreferrer');
  }
  openCrossSell() {
    this.openMessageUnitLink(this.currentMessage);
  }
  trackEngagement(message, action) {
    this.messageServiceApi.trackEngagement(BANKING_HOME_PAGE_PLACEMENT_ID, message.requestToken, action);
  }
  goRight(event) {
    // Parent component is clickable
    event.stopPropagation();

    // Go right infinitely
    if (this.cursor < this.args.messageUnits.length - 1) {
      this.cursor += 1;
    } else {
      this.cursor = 0;
    }
  }
  goLeft(event) {
    // Parent component is clickable
    event.stopPropagation();

    // Go left infinitely
    if (this.cursor > 0) {
      this.cursor -= 1;
    } else {
      this.cursor = this.args.messageUnits.length - 1;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "messageServiceApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cursor", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentMessage", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "currentMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTile", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "currentTile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTile", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "showTile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPagination", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "showPagination"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openCrossSell", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openCrossSell"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goRight", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goRight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goLeft", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goLeft"), _class.prototype)), _class));
export { BankingTile as default };